import { ReactComponent as Chemistry } from './assets/chemistry.svg'
import { ReactComponent as Doctor } from './assets/doctor.svg'
import drogasil from './assets/drogasil.png'
import { ReactComponent as Education } from './assets/education.svg'
import { ReactComponent as Football } from './assets/football.svg'
import { ReactComponent as Health } from './assets/health.svg'
import { ReactComponent as Medicine } from './assets/medicine.svg'
import raia from './assets/raia.png'

export default [
  {
    description: 'Consultas médicas <strong>com preços de R$ 50,00 na 1ª consulta e R$ 87,50 nas demais.</strong>',
    icon: Doctor,
    title: 'Saúde'
  },
  {
    description: '<strong>Descontos de até 35% nas farmácias.</strong>',
    icon: Medicine,
    logos: [{ img: drogasil, name: 'Drogasil' }, { img: raia, name: 'Droga Raia' }],
    title: 'Medicamentos'
  },
  {
    description: '<strong>Atendidas, entre elas</strong> cardiologista, ortopedista e muito mais!',
    icon: Health,
    title: '53 áreas médicas'
  },
  {
    description: '<strong>Descontos de até 20%</strong> em exames laboratoriais e de imagem.',
    icon: Chemistry,
    title: 'Exames'
  },
  {
    description: '<strong>Chance de participar de experiências</strong> exclusivas com seu time do coração.',
    icon: Football,
    title: 'Esporte'
  },
  {
    description: '<strong>Um mês grátis na Refuturiza</strong>, plataforma de ensino com mais de 1200 cursos.',
    icon: Education,
    title: 'Educação'
  }
]
